import * as types from '../mutation-types'

// initial state
const state = {
  portrait_link: null
}

// getters
const getters = {
  getPortraitLink: state => state.portrait_link
}

// actions
const actions = {
  changePortraitLink ({ commit }, payload) {
    commit(types.CHANGE_PORTRAIT_LINK, payload)
  }
}

// mutations
const mutations = {
  [types.CHANGE_PORTRAIT_LINK] (state, payload) {
    state.portrait_link = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
